<template>
  <div class="auth">
    <div style="background-color: #fff;position: relative;height:100vh;">
      <div style="font-size:.36rem;color:#333;position: fixed;top:30%;right:0;left:0;margin:auto;" class="loging">
        <img src="https://img.zhanshangxiu.com/showonline/file/202507/20250709/19cad66c5c6a405b983fe20bafb2afa9.gif" />
        <p>Loading...</p>
        <!-- 参展获取更多商机OidcCallback页面 -->
      </div>
      <div style="position: fixed;bottom: 16%;width:100%">
        <div>
          <img src="https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202009/36b5311813a4434f8c410815fa862812.png"  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
/* eslint-disable */
import Oidc from "oidc-client";

export default {
  name: "OidcCallback",
  data() {
    return {
      user: null,
    };
  },
  mounted() {
    console.log("route", this.$route.query);
    console.log("oidcUser", this.oidcUser);
    console.log('this.redirectUrl',this.redirectUrl)
    const expiresIn = localStorage.getItem("expires_in");
    // 判断是否是重定向地址返回来 避免重新加载授权出现报错 
    const login = sessionStorage.getItem("login");
    console.log(login, "login");
    if (login !== "true") {
      // 没有登录
      this.init();
    } else {
      this.$router.push(this.redirectUrl);
      return;
    }
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      redirectUrl: "getRedirectUrl",
      oidcUser: "oidcUser",
      token: "getToken",
      oidcIsAuthenticated: "oidcIsAuthenticated",
      userInfo: "getUserInfo",
    }),
  },
  methods: {
    ...mapMutations({
      setToken: "setToken",
      setExpiresIn: "setExpiresIn",
      setExhibitionId: "setExhibitionId",
      setRedirectUrl: "setRedirectUrl",
    }),
    ...mapActions({
      getUser: "login/getUser",
      getOidcUser: "getOidcUser",
      oidcSignInCallback: "oidcSignInCallback",
      getExhibitionById: "login/getExhibitionById",
      getRoomByExId: "live/getRoomByExId",
      LinkToBindEamil: "linkTo/LinkToBindEamil",
    }),
    init() {
      this.oidcSignInCallback()
        .then((redirectPath) => {
          this.getOidcUser().then((user) => {
            localStorage.setItem("access_token", user.access_token);
            localStorage.setItem("expires_in", user.expires_at);
            this.setToken(user.access_token);
            this.setExpiresIn(user.expires_at);
            this.setExhibitionId(this.exhibitionId);
            console.log(redirectPath,'ssredirectPath') 
            this.getMemberByToken(user, redirectPath);
          });
        })
        .catch((err) => {
          console.error(err);
          // this.$router.push("/oidc-callback-error"); // Handle errors any way you want
        });
    },
    async getMemberByToken(user, path) {
      // await this.getUser();
      await this.$Myapollo.getUserInfo(this);
      if (this.exhibitionId) {
        // await this.getExhibitionById(this.exhibitionId);
        await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, "");
      }
      sessionStorage.setItem("login", "true"); 
      if(user.profile.idp && user.profile.idp != 'WeixinWap') { // 微信授权
      // console.log(this.userInfo,'userInfofo') 
        if(this.userInfo && !this.userInfo.email && !this.userInfo.emailConfirmed){  // 邮箱没有绑定，需要绑定
          this.LinkToBindEamil(decodeURIComponent(path));
          return;
        }
      }

      if (path === "/auth" || path === "/") {
        let url = location.origin + "/home";
        let redirectUrl = this.redirectUrl ? location.origin + this.redirectUrl : "";
        this.$store.commit("setUrl", url);
        this.$store.commit("wxShare/setUrl", url);
        window.url = redirectUrl || url;
        console.log("!!!!!!!!!!!! 2-存入地址：", url);

        var myURL = new URL(redirectUrl || url);
        // this.$store.commit("setRedirectUrl", "");
        this.$router.replace(myURL.pathname + myURL.search);
        window.location.href = redirectUrl || url;
      } else {
        let pa = location.origin + path;  
        let redirectUrl2 = this.redirectUrl ? location.origin + this.redirectUrl : "";
        this.$store.commit("setUrl", pa);
        this.$store.commit("wxShare/setUrl", pa);
        window.url = redirectUrl2 || pa;
        // this.$store.commit("setRedirectUrl", "");
        console.log("!!!!!!!!!!!! 3-存入地址：", pa);

        var myURL = new URL(redirectUrl2 || url);
        sessionStorage.setItem("login", "true");
        this.$router.replace(myURL.pathname + myURL.search);
        window.location.href = redirectUrl2 || pa;
      }
    },
    async getUserHandle() {
      this.getOidcUser().then((user) => {
        localStorage.setItem("access_token", user.access_token);
        localStorage.setItem("expires_in", user.expires_at);
        this.setToken(user.access_token);
        this.setExpiresIn(user.expires_at);
        this.setExhibitionId(this.exhibitionId);
        this.getMemberByToken(redirectPath);
      });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  text-align: center;
  img {
    display: inline-block;
    height: 30px;
    width: 110px;
  }
}
.loging {
  img {
    width: 1.58rem;
    height: 1.58rem;
  }
}
</style>
